<template>
	<div :class="{'hidden':hidden}" class="pagination-container">
		<el-pagination
			aria-label="List pagination control, contains page number jump input"
		   :background="background"
		   :current-page.sync="currentPage"
		   :page-size.sync="pageSize"
		   :layout="layout"
		   :page-sizes="pageSizes"
		   :total="total"
		   v-bind="$attrs"
			:pager-count="5"
			@size-change="handleSizeChange"
		   @current-change="handleCurrentChange"
		  >
		</el-pagination>
	</div>
</template>
	
<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
	
  name: 'Pagination',
	props: {
		total: {
			required: true,
			type: Number
		},
		page: {
			type: Number,
			default: 1
		},
		clear_listQurey: {
			type: Object
			// default () {
			//   return {
			//     page: 1
			//   }
			// }
		},
		per_page: {
			type: Number,
			default: 10
		},
		pageSizes: {
			type: Array,
			default () {
			  return [10, 20, 30, 50]
			}
		},
		layout: {
			type: String,
			default: 'total, sizes, prev, pager, next, jumper'
		},
		background: {
			type: Boolean,
			default: true
		},
		autoScroll: {
			type: Boolean,
			default: true
		},
		hidden: {
			type: Boolean,
			default: false
		},
		pagerCount: {
			  type: Number,
			  default: 3,
			  // validator(val) {
			  //   // 如果 pager_count 不可用，或者校验不通过，返回 false
			  //   if (!val || (val < 1 && val !== 'auto') || val > this.total) {
			  //     console.error("Invalid pagerCount, must be a positive number or 'auto' and not greater than total.");
			  //     return false;
			  //   }
			  //   return true;
			  // },
		},
	},
  
  data() {
  	return {
  		pager_count: 3,
		fixTimer: null,
  	};
  },
  
	watch: {
		clear_listQurey: function (clear_listQurey) {
			this.page = clear_listQurey.page
			this.$forceUpdate()
		}
	},
  
	computed: {
		currentPage: {
			get () {
				return this.page
			},
			set (val) {
				this.$emit('update:page', val)
				console.log('执行了。。。')
			}
		 },
		 pageSize: {
			get () {
				return this.per_page
			},
			set (val) {
				this.$emit('update:per_page', val)
			}
		}
	},
	
	
	created () {
		
	},
	  
	mounted() {
		this.getPages()
		let that = this
		window.addEventListener('resize', function() {
			that.getPages()
			clearTimeout(fixTimer)
			fixTimer = setTimeout(() => that.fixPaginationAria(), 200)
		});

		// 初次加载
		this.$nextTick(() => setTimeout(() => this.fixPaginationAria(), 200))
		// 点击分页区域
		this.$el.addEventListener('click', () => {
			clearTimeout(fixTimer)
			fixTimer = setTimeout(() => that.fixPaginationAria(), 200)
		})
		this.$nextTick(() => setTimeout(() => this.set_pagination_input(), 500))
	},
	
	methods: {
		fixPaginationAria() {
		  const pagWrap = this.$el.querySelector('.el-pagination')
		  if (!pagWrap) return
		  // 跳转输入框
		  const jumpInput = pagWrap.querySelector('.el-pagination__editor .el-input__inner')
		  console.log('jumpInput', jumpInput)
		  if (jumpInput) {
		    jumpInput.setAttribute('aria-label', 'Enter target page number to jump')
		  }
		  // 每页条数下拉
		  const sizeInput = pagWrap.querySelector('.el-pagination__sizes .el-input__inner')
		  if (sizeInput) {
		    sizeInput.setAttribute('aria-label', 'Select how many items to display per page')
		  }
		  // 上下页按钮
		  const prevBtn = pagWrap.querySelector('.btn-prev')
		  const nextBtn = pagWrap.querySelector('.btn-next')
		  if (prevBtn) prevBtn.setAttribute('aria-label', 'Previous page')
		  if (nextBtn) nextBtn.setAttribute('aria-label', 'Next page')
		  // 页码数字按钮
		  const pageLiList = pagWrap.querySelectorAll('.el-pager li:not(.disabled)')
		  pageLiList.forEach(li => {
		    const pageNum = li.textContent.trim()
		    if (pageNum && !isNaN(pageNum)) {
		      li.setAttribute('aria-label', `Jump to page ${pageNum}`)
		    }
		  })
		},
		set_pagination_input(){
			// 精准选中当前组件内上传文件input
			const fileInput = this.$el.querySelector('.el-pagination__editor .el-input__inner')
			if (fileInput) {
				fileInput.setAttribute('aria-label', 'Paging input box')
			}
		},
		handleSizeChange (val) {
			console.log(val)
			this.$emit('pagination', { page: this.currentPage, per_page: val })
			if (this.autoScroll) {
				scrollTo(0, 300)
			}
			clearTimeout(this.fixTimer)
			this.fixTimer = setTimeout(() => this.fixPaginationAria(), 200)
		 },
		 
		 handleCurrentChange (val) {
			console.log(val)
			// this.$emit('pagination', { page: val, per_page: this.pageSize })
			this.$emit('pagination', { page: val })
			if (this.autoScroll) {
			  scrollTo(0, 300)
			}
			clearTimeout(this.fixTimer)
			this.fixTimer = setTimeout(() => this.fixPaginationAria(), 200)
		},
		getPages() {
			let innerWidth = window.innerWidth
			let pager_count = 3
			if(innerWidth > 1280){
				pager_count = 7
			}else if(innerWidth < 1280 && innerWidth >= 1024){
				pager_count = 6
			}else if(innerWidth < 1024 && innerWidth >= 768){
				pager_count = 7
			}else if(innerWidth < 768 && innerWidth >= 600){
				pager_count = 6
			}else if(innerWidth < 600){
				pager_count = 5
			}
			
			this.pager_count = pager_count
		},
	}
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 10px 10px;
  width: 100%;
  right: 0;
  box-sizing: border-box;
  z-index: 9;
  bottom: 0;
  overflow: auto;
  display: flex;
  justify-content: center;
}
.pagination-container .el-pagination{
  box-sizing: border-box;
}
.pagination-container.hidden {
  display: none;
}
.postPagination{
	margin-top: 10px;
	border-radius: 8px;
}
</style>

<style>
.pagination-container .el-pagination {
   white-space: nowrap;
   padding: 2px 5px;
   color: #303133;
   font-weight: 700;
   display: flex;
	align-items: center;
}
.pagination-container .el-pager{
	display: flex;
	align-items: center;
}
.pagination-container .el-pagination.is-background .el-pager li{
	min-width: 25px !important;
   line-height: 1 !important;
   display: flex !important;
   align-items: center !important;
   justify-content: center !important;
   height: 25px !important;
   font-size: 12px !important;
   border-radius: 2px;
}
.pagination-container .el-pagination.is-background .btn-next,
.pagination-container .el-pagination.is-background .btn-prev {
	min-width: 25px !important;
   height: 25px !important;
}
.pagination-container .el-pager, .el-pager li {
   vertical-align: top;
   display: inline-block;
   margin: 0;
   display: flex !important;
}
.pagination-container .el-pagination .el-select .el-input .el-input__inner,
.pagination-container .el-pagination__editor.el-input .el-input__inner {
   height: 25px;
   font-size: 12px !important;
}
.pagination-container .el-pagination__total{
   font-size: 12px !important;
	line-height: 1;
}
.pagination-container .el-input--mini .el-input__icon {
   line-height: 1;
}

.pagination-container .el-pagination__total{
	display: none !important;
}
@media screen and (max-width: 1280px) and (min-width: 1024px) {
	.pagination-container .el-pagination__total{
		display: none !important;
	}
	.pagination-container .el-pagination__sizes{
		display: none !important;
	}
}
@media screen and (max-width: 768px) {
	.pagination-container .el-pagination__total,
	.pagination-container .el-pagination__sizes,
	.pagination-container .el-pagination__jump{
		display: none !important;
	}
}
</style>
